











































import {defineComponent, PropType} from "@vue/composition-api";
import {useState} from "vuex-composition-helpers";
import {IPortalTopic} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";

export default defineComponent({
    name: "PortalAccordionItem",
    props: {
        isActive: {type: Boolean, default: false},
        topic: {type: Object as PropType<IPortalTopic>, required: true},
        isDisabled: {type: Boolean, default: false},
        index: {type: Number}
    },
    setup: () => {
        const {labels, currentlyOpenTopic} = useState(['labels', 'currentlyOpenTopic'])

        return {
            labels,
            currentlyOpenTopic,
        }
    }
})
